<template>
  <div>
    <div class="row  mt-3 mb-2">
      <div class="col-sm-12">
        <div class="float-sm-end d-flex" style="justify-content: end">
          <div class="me-2">
              <button type="button" class="btn btn-outline-primary btn-rounded mb-2 mr-2" @click="tagTaskByList()">
                <i class="mdi mdi-file-upload-outline mr-1"></i> Por lista
              </button>
              <button type="button" class="btn btn-success btn-rounded mb-2 mr-2" @click="tagTask()">
                <i class="mdi mdi-plus mr-1"></i> Nova ação
              </button>
            </div>
        </div>
      </div>
      <!-- end col-->
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="table-responsive">
          <table class="table table-centered table-hover">
            <thead>
              <tr>
                <th width="20%">Data</th>
                <th width="50%">Tarefa</th>
                <th width="10%">Lista</th>
                <th width="10%">Status</th>
                <th>#</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="list in tasktags" :key="list.id">
                <td>
                  {{ list.created_at }}
                </td>
                <td>
                  {{ list.name }}
                </td>
                <td>
                  {{ list.type_contact }} ({{ list.qty_contacts }})
                </td>
                <td>
                  <span
                    :class="list.classStatus"
                    class="badge font-size-12 p-2" style="min-width: 120px">
                      {{ list.statusLabel }}
                  </span>
                </td>
                <td>
                  <button v-if="user.role === 'Admin'" type="button" @click="detailLog(list.id)" class="link btn btn-outline-primary btn-sm"><i class="bx bx-search"></i></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row">
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-right">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @input="updateList"></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-form v-model="modalForm" ref="formTagTask" @created="updateList"></modal-form>
    <modal-form-by-list ref="formTagTaskByList" @created="updateList"></modal-form-by-list>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import ModalForm from './Form'
import ModalFormByList from './FormByList'

export default {
  components: {
    ModalForm,
    ModalFormByList
  },
  props: {
    idTemplate: {
      type: Number || String,
      default: null
    }
  },
  data () {
    return {
      title: 'Configurações de status',
      loading: true,
      fullPage: true,
      submitted: false,
      modalForm: false,
      timeout: 10000,
      params: {},
      totalRows: 1,
      currentPage: 1,
      perPage: 5
    }
  },
  mounted () {
    this.updateList()
    this.timeout = setInterval(() => {
      this.updateList()
    }, 10000)
    this.totalRows = this.pagination.total
    this.currentPage = this.pagination.current_page
  },
  beforeDestroy () {
    this.cancelAutoUpdate()
  },
  methods: {
    ...mapActions('taskTag', {
      getAll: 'getAll'
    }),
    cancelAutoUpdate () {
      clearInterval(this.timeout)
    },
    tagTask () {
      this.$refs.formTagTask.open('')
      this.modalForm = true
    },
    tagTaskByList () {
      this.$refs.formTagTaskByList.open()
    },
    detailLog (id) {
      if (this.user.role === 'Admin') {
        this.$router.push({
          name: 'task-tags-details',
          params: {
            id: id
          }
        })
      }
    },
    getReport (filter) {
      let params = {
        include: 'template',
        search: this.search || null,
        limit: this.perPage,
        page: this.currentPage
      }
      this.params = params
      let loeader = this.$loading.show()
      this.getAll(this.params).then((res) => {
        // this.participants = res.data
        this.totalRows = this.pagination.total
        this.currentPage = this.pagination.current_page
        loeader.hide()
      }).catch(error => {
        console.log(error)
        loeader.hide()
      })
    },
    updateList () {
      this.getReport(this.params)
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('taskTag', ['tasktags', 'pagination']),
    rows () {
      return this.pagination.total
    }
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style scoped>
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
</style>
